import { useMemo } from 'react';

import { slugify } from './slugify';

export type MarkdownHeading = {
  id: string;
  label: string;
  line: number;
};

const HEADING_LINE = /^>?\s*###\s/;
const FENCE_LINE = /^>?\s*(```|~~~)/;

export const parseMarkdownHeadings = (markdownContent: string): MarkdownHeading[] => {
  const seenCounts = new Map<string, number>();
  const headings: MarkdownHeading[] = [];
  let insideFence = false;

  const rawLines = markdownContent.split('\n');
  for (let lineIndex = 0; lineIndex < rawLines.length; lineIndex++) {
    const trimmedLine = rawLines[lineIndex].trim();

    if (FENCE_LINE.test(trimmedLine)) {
      insideFence = !insideFence;
      continue;
    }
    if (insideFence) continue;

    const match = HEADING_LINE.exec(trimmedLine);
    if (!match) continue;

    const label = trimmedLine.slice(match[0].length).trim();
    const baseId = slugify(label);
    const priorCount = seenCounts.get(baseId) ?? 0;
    seenCounts.set(baseId, priorCount + 1);
    const id = priorCount === 0 ? baseId : `${baseId}-${priorCount + 1}`;

    headings.push({ id, label, line: lineIndex + 1 });
  }

  return headings;
};

export const useMarkdownHeadings = (markdownContent: string): MarkdownHeading[] =>
  useMemo(() => parseMarkdownHeadings(markdownContent), [markdownContent]);
